import { render, staticRenderFns } from "./ModalConsumer.vue?vue&type=template&id=2d20c32b&"
import script from "./ModalConsumer.vue?vue&type=script&lang=js&"
export * from "./ModalConsumer.vue?vue&type=script&lang=js&"
import style0 from "./ModalConsumer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports